import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://dbng745h-fdf.fermerchel74.ru";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzY5MjQyNDg5LCJleHAiOjIwODQ2MDI0ODl9.PYh5duDQeWynhWF4oi12BdXbCKMzL-tEWQRD5rYocik";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
